import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LauoutRoutingModule } from './layout-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LobbyComponent } from '../pages/lobby/lobby.component';
import { NewsHeaderComponent } from '../pages/news-header/news-header.component';
import { LoadIframeComponent } from '../pages/load-iframe/load-iframe.component';
// import { MarketHistoryComponent } from '../pages/market-history/market-history.component';
// import { RoundHistoryComponent } from '../pages/round-history/round-history.component';
import { ChipsSettingComponent } from '../pages/chips-setting/chips-setting.component';
import { SharedModule } from '../common/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { WidgetComponent } from '../pages/widget/widget.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
// import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ViewSkeletonComponent } from '../view-skeleton/view-skeleton.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    LobbyComponent,
    NewsHeaderComponent,
    LoadIframeComponent,
    // MarketHistoryComponent,
    // RoundHistoryComponent,
    // ErrorComponent,
    ChipsSettingComponent,
    WidgetComponent,
    ViewSkeletonComponent,
  ],
  imports: [
    LauoutRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbModule,
    SwiperModule,
    // SlickCarouselModule,
    TranslateModule
  ],
  exports: [
    TranslateModule
  ]
})
export class LayoutModule { }
